import React,{useState,useEffect,useRef}from 'react'
import { Modal, Form, Input, App, Radio } from 'antd';
import { useCapitalAccountUpdateQuery, useCapitalAccountUpdateSaveMutation } from '../../store/ReactWebSiteApi';

function AccountEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const editForm = useRef()
    const {data,isSuccess} = useCapitalAccountUpdateQuery({eca_id:props.eca_id},{skip:!open})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                editForm.current.setFieldsValue({
                    eca_type_id:data.Result.eca_type_id,
                    eca_bank_kh:data.Result.eca_bank_kh,
                    eca_bank_zh:data.Result.eca_bank_zh,
                    eca_bank_crad:data.Result.eca_bank_crad,
                    eca_bank_content:data.Result.eca_bank_content,
                    eca_wx_phone:data.Result.eca_wx_phone,
                    eca_wx_account:data.Result.eca_wx_account,
                    eca_wx_content:data.Result.eca_wx_content,
                    eca_alipay_phone:data.Result.eca_alipay_phone,
                    eca_alipay_account:data.Result.eca_alipay_account,
                    eca_alipay_content:data.Result.eca_alipay_content,
                })
                setInfoEdit(prevState=>({...prevState,
                    eca_type_id:data.Result.eca_type_id,
                    eca_bank_kh:data.Result.eca_bank_kh,
                    eca_bank_zh:data.Result.eca_bank_zh,
                    eca_bank_crad:data.Result.eca_bank_crad,
                    eca_bank_content:data.Result.eca_bank_content,
                    eca_wx_phone:data.Result.eca_wx_phone,
                    eca_wx_account:data.Result.eca_wx_account,
                    eca_wx_content:data.Result.eca_wx_content,
                    eca_alipay_phone:data.Result.eca_alipay_phone,
                    eca_alipay_account:data.Result.eca_alipay_account,
                    eca_alipay_content:data.Result.eca_alipay_content,              
                }))
            }
        }
    },[data,isSuccess])
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [infoEdit,setInfoEdit] = useState({
        eca_type_id:'',
        eca_uid:localStorage.getItem('eu_id'),
        eca_uname:localStorage.getItem('eu_name'),
        eca_e_id:localStorage.getItem('e_id'),
        eca_id:props.eca_id,
    });
    const [EditData] = useCapitalAccountUpdateSaveMutation()
    return (
        <>
           {props.eca_state ==='2' && <a onClick={() => {setOpen(true)}}>修改</a>}
            <Modal
                open={open}
                title='修改支付账户'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    EditData(infoEdit).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 5 }}
                    ref={editForm}
                >
                    <Form.Item name="eca_type_id" label='账户类型' wrapperCol={{span:10}}>
                            <Radio.Group onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_type_id:e.target.value}))}}>
                                <Radio value='1'>银行账户</Radio>
                                <Radio value='2'>微信</Radio>
                                <Radio value='3'>支付宝</Radio>
                            </Radio.Group>
                        </Form.Item>
                        {infoEdit.eca_type_id==='1' && <>
                            <Form.Item name="eca_bank_kh" label='开户行' wrapperCol={{span:15}} required>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_bank_kh:e.target.value}))}}/>
                            </Form.Item>
                            <Form.Item name="eca_bank_zh" label='账户名称' wrapperCol={{span:15}} required>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_bank_zh:e.target.value}))}}/>
                            </Form.Item>
                            <Form.Item name="eca_bank_crad" label='账号' wrapperCol={{span:15}} required>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_bank_crad:e.target.value}))}} type='number'/>
                            </Form.Item>
                            <Form.Item name="eca_bank_content" label='备注' wrapperCol={{span:15}}>
                                <Input onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_bank_content:e.target.value}))}} />
                            </Form.Item>
                        </>}
                        {infoEdit.eca_type_id==='2' && <>
                            <Form.Item name="eca_wx_phone" label='手机号码' wrapperCol={{span:10}}>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_wx_phone:e.target.value}))}}/>
                            </Form.Item>
                            <Form.Item name="eca_wx_account" label='微信号' wrapperCol={{span:10}}>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_wx_account:e.target.value}))}}/>
                            </Form.Item>
                            <Form.Item name="eca_wx_content" label='备注' wrapperCol={{span:15}}>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_wx_content:e.target.value}))}}/>
                            </Form.Item>
                        </>}
                        {infoEdit.eca_type_id==='3' && <>
                            <Form.Item name="eca_alipay_phone" label='手机号码' wrapperCol={{span:10}}>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_alipay_phone:e.target.value}))}}/>
                            </Form.Item>
                            <Form.Item name="eca_alipay_account" label='支付宝账号' wrapperCol={{span:10}}>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_alipay_account:e.target.value}))}}/>
                            </Form.Item>                            
                            <Form.Item name="eca_alipay_content" label='备注' wrapperCol={{span:15}}>
                                <Input   onChange={(e) => {setInfoEdit(prevState=>({...prevState,eca_alipay_content:e.target.value}))}}/>
                            </Form.Item>
                        </>}
                </Form>
            </Modal> 
        </>
    )
}

export default AccountEdit